const initialState = {
    jobDetails: {},
    basicDetails: {},
    hrCompanyDetails: {},
    directorCompanyDetails: {},
    visitFindings: {},
    generalRemarks: {},
    relatedDataSearch: {},
    alert: {},
    grievance: {},
    loadingOccupationData: false,
    errorsOccupationData: {}
};

const occupationDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SAVE_JOB_DETAILS_PENDING':
        case 'SAVE_BASIC_DETAILS_PENDING':
        case 'SAVE_COMPANY_HR_DETAILS_PENDING':
        case 'SAVE_COMPANY_DIRECTOR_DETAILS_PENDING':
        case 'SAVE_VISIT_FINDINGS_PENDING':
        case 'SAVE_GENERAL_REMARKS_PENDING':
        case 'SAVE_RELATED_DATA_SEARCH_PENDING':
        case 'OCCUPATION_ALERT_PENDING':
        case 'OCCUPATION_GRIEVANCE_PENDING':
            return { ...state, loadingOccupationData: true };

        case 'SAVE_JOB_DETAILS_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                jobDetails: action.payload,
                errorsOccupationData: {}
            };

        case 'SAVE_BASIC_DETAILS_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                basicDetails: action.payload,
                errorsOccupationData: {}
            };

        case 'SAVE_COMPANY_HR_DETAILS_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                hrCompanyDetails: action.payload,
                errorsOccupationData: {}
            };

        case 'SAVE_COMPANY_DIRECTOR_DETAILS_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                directorCompanyDetails: action.payload,
                errorsOccupationData: {}
            };

        case 'SAVE_VISIT_FINDINGS_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                visitFindings: action.payload,
                errorsOccupationData: {}
            };

        case 'SAVE_GENERAL_REMARKS_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                generalRemarks: action.payload,
                errorsOccupationData: {}
            };

        case 'SAVE_RELATED_DATA_SEARCH_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                relatedDataSearch: action.payload,
                errorsOccupationData: {}
            };

        case 'OCCUPATION_ALERT_FULFILLED':
            return {
                ...state,
                loadingOccupationData: false,
                alert: action.payload,
                errorsOccupationData: {}
            };  

        case 'OCCUPATION_GRIEVANCE_FULFILLED':

            return {
                ...state,
                loadingOccupationData: false,
                grievance: action.payload,
                errorsOccupationData: {}
            };  

        case 'SAVE_JOB_DETAILS_REJECTED':
        case 'SAVE_BASIC_DETAILS_REJECTED':
        case 'SAVE_COMPANY_HR_DETAILS_REJECTED':
        case 'SAVE_COMPANY_DIRECTOR_DETAILS_REJECTED':
        case 'SAVE_VISIT_FINDINGS_REJECTED':
        case 'SAVE_GENERAL_REMARKS_REJECTED':
        case 'SAVE_RELATED_DATA_SEARCH_REJECTED':
        case 'OCCUPATION_ALERT_REJECTED':
        case 'OCCUPATION_GRIEVANCE_REJECTED':
            return {
                ...state,
                loadingOccupationData: false,
                errorsOccupationData: action.payload
            };

        case 'RESET_OCCUPATION_DATA_ERRORS':
            return {
                ...state,
                errorsOccupationData: {}
            };

        case 'RESET_JOB_DETAILS':
            return {
                ...state,
                jobDetails: {}
            };

        case 'RESET_BASIC_DETAILS':
            return {
                ...state,
                basicDetails: {}
            };

        case 'RESET_HR_DETAILS':
            return {
                ...state,
                hrCompanyDetails: {}
            };

        case 'RESET_DIRECTOR_DETAILS':
            return {
                ...state,
                directorCompanyDetails: {}
            };

        case 'RESET_VISIT_FINDINGS':
            return {
                ...state,
                visitFindings: {}
            };

        case 'RESET_GENERAL_REMARKS':
            return {
                ...state,
                generalRemarks: {}
            };

        case 'RESET_RELATED_DATA_SEARCH':
            return {
                ...state,
                relatedDataSearch: {}
            };

        case 'RESET_OCCUPATION_ALERT':

            return {
                ...state,
                alert: {}
            };

        case 'RESET_OCCUPATION_GRIEVANCE':

            return {
                ...state,
                grievance: {}
            };

        case 'RESET_CHANGED_OCCUPATION_DATA_STATUS':
            return {
                ...state,
                changedOccupationDataStatus: {}
            };

        default:
            return state;
    }
};

export default occupationDataReducer; 